angular
  .module('contabilidad.polizas')
  .service('exportarService', Service)

function Service ($http, $file, ContabilidadPolizasDeudoresDiversos, deudoresDiversosEgresosService,
                  facturacionService, provisionIngresosPagos, provisionNominaService,
                  pagosNominasMXNService, pagosNominasUSDService, noDeduciblesService,
                  ProvisionGastosService, provisionGastosPagosService, ContabilidadPolizasProvisionnominaconpagos,
                  ContabilidadPolizasFacturascanceladas, ContabilidadPolizasProvisionnominaconpagosSucursales) {

  var exportarService = this

  exportarService.exportarPoliza = exportarPoliza

  function exportarPoliza (data, inicio_poliza, archivo, tipo_poliza, fecha_inicio, nominas) {
    var contenido
    var poliza = {}
    if (tipo_poliza === 'deudoresDiversos') {
      contenido = ContabilidadPolizasDeudoresDiversos.codificar(data, inicio_poliza)
    } else if (tipo_poliza === 'provisionNomina') {
      contenido = provisionNominaService.codificarProvisionNomina(data, inicio_poliza, fecha_inicio)
    } else if (tipo_poliza === 'facturacion') {
      contenido = facturacionService.codificarFacturacion(data, inicio_poliza, fecha_inicio)
    } else if (tipo_poliza === 'pagosNominaMXN') {
      contenido = pagosNominasMXNService.codificarPagosNominaMXN(data, inicio_poliza)
    } else if (tipo_poliza === 'pagosNominaUSD') {
      contenido = pagosNominasUSDService.codificarPagosNominaUSD(data, inicio_poliza)
    } else if (tipo_poliza === 'provisionIngresosPagos') {
      contenido = provisionIngresosPagos.condificarProvisionIngresosPagos(data, inicio_poliza)
    } else if (tipo_poliza === 'deudoresDiversosEgresos') {
      contenido = deudoresDiversosEgresosService.condificardeudoresDiversosEgresos(data, inicio_poliza)
    } else if (tipo_poliza === 'gastosNoDeducibles') {
      contenido = noDeduciblesService.codificar(data, inicio_poliza)
    } else if (tipo_poliza === 'provisionpagos') {
      contenido = ProvisionGastosService.codificar(data, inicio_poliza)
    } else if (tipo_poliza === 'provisionGastosPagos') {
      contenido = provisionGastosPagosService.codificar(data, inicio_poliza)
    } else if (tipo_poliza === 'provisionNominaconpagos') {
      contenido = ContabilidadPolizasProvisionnominaconpagos.codificar(data, inicio_poliza, nominas)
      poliza = {nominas: nominas, poliza: 11}
    } else if (tipo_poliza === 'facturacioncanceladas') {
      contenido = ContabilidadPolizasFacturascanceladas.codificar(data, inicio_poliza)
      // poliza = { fecha_inicio : fecha_inicio.toYMD, fecha_fin : fecha_fin.toYMD,  empresas : empresas, poliza : 12};
    } else if (tipo_poliza === 'provisionNominaconpagossucursales') {
      contenido = ContabilidadPolizasProvisionnominaconpagosSucursales.codificar(data, inicio_poliza, nominas)
      poliza = {nominas: nominas, poliza: 11}
    }

    if (contenido !== 'Error') {
      $http.post('/kendu/contabilidad/polizas/exportar', {
        poliza: poliza,
        archivo: archivo,
        contenido: contenido,
      }, {
        responseType: 'arraybuffer',
      }).then(function (response) {
        var file = new File([response.data], archivo + '.txt', {type: 'text/plain'})

        return $file.saveAs(file)
      })
      return 'OK'
    } else {
      return 'Error'
    }
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/exportarService.js